var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 16.875V24.375H19.25V16.875H13.625L23 7.5L32.375 16.875H26.75ZM36.7812 11.3062C35.5063 4.85625 29.825 0 23 0C17.5812 0 12.875 3.075 10.5312 7.55625C4.8875 8.175 0.5 12.9375 0.5 18.75C0.5 21.7337 1.68526 24.5952 3.79505 26.705C5.90483 28.8147 8.76631 30 11.75 30H36.125C37.3561 30 38.5752 29.7575 39.7127 29.2864C40.8501 28.8152 41.8836 28.1247 42.7541 27.2541C43.6247 26.3836 44.3152 25.3501 44.7864 24.2127C45.2575 23.0752 45.5 21.8561 45.5 20.625C45.5 15.675 41.6562 11.6625 36.7812 11.3062Z",
    fill: "#929CA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.dfd56f32a3453c57159f040da3967d7b.svg";
export { ForwardRef as ReactComponent };